import { memo } from 'react'
import { Rectangle as GoogleMapRectangle } from '@react-google-maps/api'

import './styles.less'

interface Coordinate {
  Latitude: number
  Longitude: number
}

interface RectangleProps {
  color: string
  start: Coordinate
  end: Coordinate
}

const Rectangle: React.FC<RectangleProps> = ({ start, end, color, ...rest }) => {
  return (
    <GoogleMapRectangle
      bounds={{
        north: start.Latitude,
        east: start.Longitude,
        south: end.Latitude,
        west: end.Longitude,
      }}
      options={{
        fillColor: color,
        strokeColor: color,
      }}
      {...rest}
    />
  )
}

export default memo(Rectangle)
